/**
 * Helper pur de formatage de tailles d octets en chaine humaine.
 * Pas de dep externe (testable directement).
 *
 * Exemple : 1024 -> "1.0 KB", 1500000 -> "1.4 MB"
 */

/**
 * @param {number | null | undefined} bytes
 * @returns {string}
 */
export function formatBytes(bytes) {
  if (bytes === null || bytes === undefined || Number.isNaN(bytes)) return '';
  if (bytes < 0) return '';
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let value = Number(bytes);
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i += 1;
  }
  // 1 decimale a partir de KB, 0 pour les bytes purs
  const formatted = i === 0 ? Math.round(value) : value.toFixed(1);
  return `${formatted} ${units[i]}`;
}

/**
 * Formatage d un timestamp en "il y a X minutes/heures/jours".
 * @param {string | Date | null | undefined} ts
 * @param {Date} [now]
 * @returns {string}
 */
export function timeAgo(ts, now = new Date()) {
  if (!ts) return '';
  const date = ts instanceof Date ? ts : new Date(ts);
  if (Number.isNaN(date.getTime())) return '';
  const diffMs = now.getTime() - date.getTime();
  const diffMin = Math.round(diffMs / 60000);
  if (diffMin < 1) return "a l instant";
  if (diffMin < 60) return `il y a ${diffMin} min`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `il y a ${diffH} h`;
  const diffD = Math.round(diffH / 24);
  if (diffD < 30) return `il y a ${diffD} j`;
  const diffMo = Math.round(diffD / 30);
  if (diffMo < 12) return `il y a ${diffMo} mois`;
  const diffY = Math.round(diffMo / 12);
  return `il y a ${diffY} an${diffY > 1 ? 's' : ''}`;
}
